import axios from "axios";
const BASE_URL = "https://api.boque.me/v1/";
//const BASE_URL = "https://api-staging.boque.me/v1/";
//const BASE_URL = "http://localhost:3004/v1/";

const deviceType = "Desktop";
const os = "Windows";
const osVersion = "1.0";
const signature =
  "z2d5akpzmbn0n0vyjptzlcsi59ucoedy4qir800zpsz9mgx1jbqikfov4zdb";
const appSecret = "kjafhJQKQJNWJNjqnjjqjnnNNWJNJQNJWJNjnqjjNQJNWJNQj";

export const mainApi = axios.create({
  baseURL: BASE_URL,
  withCredentials: true,
  headers: {
    "Access-Control-Allow-Origin": true,
    Accept: "*/*",
    "Content-Type": "application/json",
    "device-type": deviceType,
    os: os,
    "os-version": osVersion,
    signature: signature,
    "app-secret": appSecret,
  },
  //   withCredentials: true,
  //   headers: {
  //     "Access-Control-Allow-Origin": true,
  //   },
});

mainApi.defaults.headers.common["Content-Type"] = "application/json";

// mainApi.interceptors.request.use(
//   async (config) => {
//     const token = localStorage.getItem("token");
//     if (token) {
//       config.headers["authorization"] = `Bearer ${token}`;
//     }
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export const getGroup = async (username) => {
  const response = await mainApi.get(`groups/single/${username}`);
  return response.data;
};

export const getInvite = async (token) => {
  const response = await mainApi.get(`invites/single/${token}`);
  return response.data;
};

export const verifyEmail = async (params) => {
  const response = await mainApi.put(
    `/users/verify-email`,
    JSON.stringify(params)
  );
  return response.data;
};
